<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col">
                    <h6 class="font-weight-normal">{{ $t(`${modelTranslateID}.title`) }}</h6>
                    <hr class="mt-1" />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div id="layer-types-accordion">
                        <div class="card accordion" v-for="(type, idx) in subtypes" :key="`type-${idx}`">
                            <div class="card-header">
                                <div class="row no-gutters">
                                    <div class="col" :id="'heading' + type.id" data-toggle="collapse"
                                        :data-target="'#collapse' + type.id" aria-expanded="true"
                                        :aria-controls="'collapse' + type.id">
                                        {{ type.name }}
                                    </div>
                                </div>
                            </div>
                            <div :id="'collapse' + type.id" class="collapse" :aria-labelledby="'heading' + type.id"
                                data-parent="#layer-types-accordion">
                                <div class="card-body py-3">
                                    <div class="form-check city-form-check px-0 px-sm-2 mb-1" :key="subtype.id"
                                        v-for="subtype in type.subtypes">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :disabled="readonlyForm"
                                            v-model="items"
                                            :value="valueCheckbox(subtype.id)"
                                            :id="'checkSubtype' + subtype.id"
                                            :name="'checkSubtype' + subtype.id"
                                            v-validate="''"
                                            :data-vv-scope="vScope">
                                        <label class="form-check-label" :for="'checkSubtype' + subtype.id">
                                            {{ subtype.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ElementMixin from './../mixins/ElementMixin';

export default {
    name: 'LayerSubtype',
    mixins: [
        ElementMixin,
    ],
    props: {
        value: {
            type: Array,
            default: () => {
                return [];
            },
        },
        propertyId: {
            type: String,
            default: 'subtype_id',
        },
        idSubPanel: {
            type: String,
            default: 'subtypes',
        },
        subtypes: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            items: this.value,
        }
    },
    methods: {
        valueCheckbox(id) {
            return {...(this.items.find(item => item[this.propertyId] == id) ?? { [this.propertyId]: id })};
        }
    },
    watch: {
        value: {
            immediate: false,
            deep: true,
            handler: function(value, oldValue){
                this.items = value;
            }
        },
        items: {
            deep: true,
            handler: function(value, oldValue){
                this.$emit('input', value);
            }
        },
    }
}
</script>

<style></style>